module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_assegna-b0292804ab4ba3e8531edd6752a6b3bb.svg";